export default __webpack_public_path__ + "static/media/Deathswoop.3215ffdc.jpg";